/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Demo_Accounts_NoteInputs */

const th_demo_accounts_note = /** @type {(inputs: Demo_Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บัญชีทดลอง — รหัสเปิดเผย`)
};

const en_demo_accounts_note = /** @type {(inputs: Demo_Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DEMO — PUBLISHED CODE`)
};

const ja_demo_accounts_note = /** @type {(inputs: Demo_Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デモ — コードは公開されています`)
};

const zh_demo_accounts_note = /** @type {(inputs: Demo_Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`演示 — 公开代码`)
};

const es_demo_accounts_note = /** @type {(inputs: Demo_Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DEMOSTRACIÓN — CÓDIGO PUBLICADO`)
};

const pt_demo_accounts_note = /** @type {(inputs: Demo_Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DEMONSTRAÇÃO — CÓDIGO PUBLICADO`)
};

const id_demo_accounts_note = /** @type {(inputs: Demo_Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DEMO — KODE PUBLIK`)
};

const fr_demo_accounts_note = /** @type {(inputs: Demo_Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DÉMO — CODE PUBLIÉ`)
};

const tl_demo_accounts_note = /** @type {(inputs: Demo_Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DEMO — PAMPUBLIKONG CODE`)
};

const vi_demo_accounts_note = /** @type {(inputs: Demo_Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BẢN DEMO — MÃ CÔNG KHAI`)
};

const ko_demo_accounts_note = /** @type {(inputs: Demo_Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`데모 — 공개된 코드`)
};

const de_demo_accounts_note = /** @type {(inputs: Demo_Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DEMO — VERÖFFENTLICHTER CODE`)
};

const ru_demo_accounts_note = /** @type {(inputs: Demo_Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ДЕМО — ОТКРЫТЫЙ КОД`)
};

const tr_demo_accounts_note = /** @type {(inputs: Demo_Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DEMO — AÇIK KAYNAK KOD`)
};

const it_demo_accounts_note = /** @type {(inputs: Demo_Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DEMO — CODICE PUBBLICO`)
};

const pl_demo_accounts_note = /** @type {(inputs: Demo_Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DEMO — KOD PUBLICZNY`)
};

const uk_demo_accounts_note = /** @type {(inputs: Demo_Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ДЕМО — ВІДКРИТИЙ КОД`)
};

const hi_demo_accounts_note = /** @type {(inputs: Demo_Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डेमो — सार्वजनिक कोड`)
};

const ar_demo_accounts_note = /** @type {(inputs: Demo_Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عرض توضيحي — شفرة معلنة`)
};

const ms_demo_accounts_note = /** @type {(inputs: Demo_Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DEMO — KOD AWAM`)
};

const bn_demo_accounts_note = /** @type {(inputs: Demo_Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডেমো — উন্মুক্ত কোড`)
};

const zh_tw2_demo_accounts_note = /** @type {(inputs: Demo_Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`示範 — 公開程式碼`)
};

const zh_hk2_demo_accounts_note = /** @type {(inputs: Demo_Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`示範 — 公開程式碼`)
};

const ur_demo_accounts_note = /** @type {(inputs: Demo_Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ڈیمو — عوامی کوڈ`)
};

const fa_demo_accounts_note = /** @type {(inputs: Demo_Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نمونه — کد عمومی`)
};

const sw_demo_accounts_note = /** @type {(inputs: Demo_Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ONYESHO — MSIMBO WA WAZI`)
};

const nl_demo_accounts_note = /** @type {(inputs: Demo_Accounts_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DEMO — OPENBARE CODE`)
};

/**
* | output |
* | --- |
* | "DEMO — PUBLISHED CODE" |
*
* @param {Demo_Accounts_NoteInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const demo_accounts_note = /** @type {((inputs?: Demo_Accounts_NoteInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Demo_Accounts_NoteInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_demo_accounts_note(inputs)
	if (locale === "ja") return ja_demo_accounts_note(inputs)
	if (locale === "zh") return zh_demo_accounts_note(inputs)
	if (locale === "es") return es_demo_accounts_note(inputs)
	if (locale === "pt") return pt_demo_accounts_note(inputs)
	if (locale === "id") return id_demo_accounts_note(inputs)
	if (locale === "fr") return fr_demo_accounts_note(inputs)
	if (locale === "tl") return tl_demo_accounts_note(inputs)
	if (locale === "vi") return vi_demo_accounts_note(inputs)
	if (locale === "ko") return ko_demo_accounts_note(inputs)
	if (locale === "de") return de_demo_accounts_note(inputs)
	if (locale === "ru") return ru_demo_accounts_note(inputs)
	if (locale === "tr") return tr_demo_accounts_note(inputs)
	if (locale === "it") return it_demo_accounts_note(inputs)
	if (locale === "pl") return pl_demo_accounts_note(inputs)
	if (locale === "uk") return uk_demo_accounts_note(inputs)
	if (locale === "hi") return hi_demo_accounts_note(inputs)
	if (locale === "ar") return ar_demo_accounts_note(inputs)
	if (locale === "ms") return ms_demo_accounts_note(inputs)
	if (locale === "bn") return bn_demo_accounts_note(inputs)
	if (locale === "zh-TW") return zh_tw2_demo_accounts_note(inputs)
	if (locale === "zh-HK") return zh_hk2_demo_accounts_note(inputs)
	if (locale === "ur") return ur_demo_accounts_note(inputs)
	if (locale === "fa") return fa_demo_accounts_note(inputs)
	if (locale === "sw") return sw_demo_accounts_note(inputs)
	if (locale === "nl") return nl_demo_accounts_note(inputs)
	return en_demo_accounts_note(inputs)
});